import { SearchClient as TypesenseSearchClient } from "typesense";

// Typesense client
export const typesenseClient = new TypesenseSearchClient({
  ...v.parse(typesenseSchema, typesense),
  sendApiKeyAsQueryParam: false,
});
